// extracted by mini-css-extract-plugin
module.exports = {"bankID":"styles_bankID__3gRC2","cancelButton":"styles_cancelButton__3YuI7"};